import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.92 25.07 47.92 47.83 26.24 47.92 16.72 30.39 29.37 9.13 47.92 25.07"
  />
);

export let NeytiriAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.neytiri}
    renderShadow={renderShadow}
  >
    <>
      <path
        d="m28.57,25.1c-.13,2.84-.06,5.72.74,8.45.43,1.45,1.06,2.83,1.45,4.29s.51,3.06-.08,4.45c-.18.42-.43.84-.45,1.3s.29.98.75.97c.42-.01.7-.43.88-.8,1.02-2.14,1.31-4.62.82-6.93-.18-.84-.46-1.65-.64-2.49-.3-1.38-.33-2.81-.52-4.21-.15-1.16-.41-2.3-.77-3.41-.4-1.22-.96-2.46-1.97-3.25"
        style={{
          fill: '#312c32',
          stroke: '#140f12',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m28.45,21.21l1.88,5.82c.33,1.01.65,2.02.82,3.06.34,2.1,0,4.3-.93,6.21-.37.75-.83,1.46-1.12,2.25s-.38,1.69-.02,2.44c.25.5.94.91,1.34.53.18-.17.23-.43.26-.67.14-1,.19-2.01.42-2.99.51-2.22,1.88-4.21,2.11-6.47.22-2.15-.61-4.27-1.54-6.22s-1.99-3.91-2.26-6.06"
        style={{
          fill: '#312c32',
          stroke: '#140f12',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m32.26,22.65c.39,3.14-1.99,5.96-2.35,9.09-.23,2,.41,4.08,1.73,5.6.75.86,1.74,1.62,1.99,2.74.07.31.07.66-.11.93s-.69.59-.93.38c-2.18-1.84-4.29-4.11-4.66-6.94-.53-4.12,2.8-7.86,2.83-12"
        style={{
          fill: '#312c32',
          stroke: '#140f12',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="m32.65,17.19s-.3,8.11-1.16,10.66c-.72,2.14-2.94,4.88-5.24,7.42-1.48,1.63-4.08,1.64-5.57.02-2.33-2.54-4.58-5.28-5.31-7.43-.87-2.54-1.16-10.66-1.16-10.66-.08-1.55,4.82-6.54,4.82-6.54,1.86-1.1,6.54-1.11,8.4-.01,0,0,5.3,5.01,5.23,6.56Z"
        style={{
          fill: '#69c8fb',
        }}
      />
      <path
        d="m26.24,32.18c.19-.26-.23-.54-.83-.68s-1.31-.16-2-.16c-.65,0-1.32.03-1.89.15s-1.01.36-.95.62c0,.03.02.06.07.08.07.03.19.04.29.05,1.4.1,2.83.14,4.25.13.33,0,.68,0,.96-.08"
        style={{
          fill: '#10528c',
        }}
      />
      <path
        d="m26.28,32.22c-.46.59-1.61.9-2.8.91s-2.35-.3-2.83-.88c-.02-.02-.04-.05,0-.07.02-.02.06-.02.1-.02.82-.04,1.59.18,2.6.18s2.48-.14,2.97-.21l-.03.1Z"
        style={{
          fill: '#4b6f8f',
        }}
      />
      <path
        d="m12.04,17.27c-.12-.62-.4-1.33-.72-2.05,1.1,1.11,2.6,1.96,3.45,3.18.38.54.33,1.37.63,1.91.29.51.58,1.02.88,1.53.78,1.35,1.59,2.9,1.21,3.54-.13.21-.43.29-.85.03-.3-.18-.39-1.64-.67-1.94-.8-.82-1.78.34-2.47-.55s-.88-2.39-1.03-3.12c0,0-.29-1.83-.43-2.54Z"
        style={{
          fill: '#69c8fb',
        }}
      />
      <path
        d="m12.41,17.17c-.16-.74-.45-1.45-.76-2.14l-.61.47c.67.66,1.42,1.2,2.13,1.81.66.56,1.32,1.14,1.52,2.01.08.36.14.73.3,1.07.24.51.56.99.84,1.48.46.81.98,1.64,1.25,2.54.06.19.25.79-.06.77-.3-.02-.32-.57-.37-.79-.13-.57-.22-1.14-.78-1.44-.25-.13-.53-.18-.81-.16-.31.02-.69.18-1,.1-.66-.17-.91-1.53-1.03-2.09-.27-1.2-.41-2.42-.64-3.63-.09-.49-.83-.28-.74.21.24,1.27.38,2.57.68,3.83.18.74.46,1.78,1.13,2.24.27.19.59.24.92.21.35-.03.82-.23,1.15-.02.27.17.29.61.35.89.07.32.13.68.3.97.36.58,1.34.63,1.65,0,.35-.7-.11-1.63-.41-2.27-.5-1.08-1.21-2.05-1.72-3.11-.24-.5-.25-1.06-.46-1.57-.2-.48-.58-.89-.95-1.25-.86-.84-1.87-1.51-2.73-2.35-.33-.33-.77.08-.61.47.28.63.54,1.28.68,1.96.1.49.85.28.74-.21Z"
        style={{
          fill: '#69c8fb',
        }}
      />

      <path
        d="m15.85,28.95c.54.06,1.15-.25,2,.35.53.37.98.89,1.6,1.1.12-.5-1-2.03-1.32-2.28-1.01-.81-2.43-.59-2.84-.61,0,0,.03.52.56,1.44Z"
        style={{
          fill: '#4ba0d7',
        }}
      />
      <path
        d="m14.81,25.03c.19.03.91-.25,2,.14,1.39.49,2.97,2.12,3.49,2.33-.28-1.7-2.69-3.58-3.08-3.93-.82-.73-2.56.08-2.56.08l.16,1.38Z"
        style={{
          fill: '#4ba0d7',
        }}
      />
      <path
        d="m34.84,17.27c.12-.62.4-1.33.72-2.05-1.1,1.11-2.6,1.96-3.45,3.18-.38.54-.33,1.37-.63,1.91-.29.51-.58,1.02-.88,1.53-.78,1.35-1.59,2.9-1.21,3.54.13.21.43.29.85.03.3-.18.39-1.64.67-1.94.8-.82,1.78.34,2.47-.55s.88-2.39,1.03-3.12c0,0,.29-1.83.43-2.54Z"
        style={{
          fill: '#69c8fb',
        }}
      />
      <path
        d="m35.21,17.37c.14-.68.4-1.32.68-1.96.16-.38-.27-.8-.61-.47-.76.75-1.65,1.36-2.44,2.08-.36.32-.69.67-.98,1.06s-.4.84-.5,1.32c-.24,1.09-1.01,2.06-1.54,3.04-.41.75-.95,1.69-.92,2.58.03.8.76,1.16,1.45.76.58-.33.56-1.19.73-1.76.25-.84,1.18-.28,1.81-.38.82-.14,1.19-1.05,1.43-1.75.49-1.44.6-3.03.88-4.52.09-.49-.65-.69-.74-.21-.19,1.02-.33,2.04-.52,3.06-.15.78-.31,1.61-.74,2.29s-1.1.2-1.75.28-.99.54-1.14,1.13c-.08.3-.13.6-.21.9-.02.08-.04.22-.1.28-.19.19-.32.06-.33-.14-.05-.82.61-1.78.99-2.46.45-.81,1.1-1.64,1.36-2.54.13-.46.16-.96.42-1.37s.65-.76,1.01-1.08c.78-.69,1.64-1.29,2.38-2.02l-.61-.47c-.3.7-.6,1.4-.76,2.14-.1.48.64.69.74.21Z"
        style={{
          fill: '#69c8fb',
        }}
      />
      <circle
        cx="14"
        cy="22.62"
        r=".65"
        style={{
          fill: '#312c32',
          stroke: '#0c0f38',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <circle
        cx="32.91"
        cy="22.62"
        r=".65"
        style={{
          fill: '#312c32',
          stroke: '#0c0f38',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.75,
        }}
      />
      <path
        d="m31.03,28.95c-.54.06-1.15-.25-2,.35-.53.37-.98.89-1.6,1.1-.12-.5,1-2.03,1.32-2.28,1.01-.81,2.43-.59,2.84-.61,0,0-.03.52-.56,1.44Z"
        style={{
          fill: '#4ba0d7',
        }}
      />
      <path
        d="m32.06,25.03c-.19.03-.91-.25-2,.14-1.39.49-2.97,2.12-3.49,2.33.28-1.7,2.69-3.58,3.08-3.93.82-.73,2.56.08,2.56.08l-.16,1.38Z"
        style={{
          fill: '#4ba0d7',
        }}
      />
      <path
        d="m22.52,14.15c-.06,2.36.99,6.03,1.4,8.35.44-2.51.66-5.84,1.1-8.35"
        style={{
          fill: '#4ba0d7',
        }}
      />
      <path
        d="m14.03,13.8c-.65-1.36.43-2.51,1.06-2.29.33-.41,1.18-2.29,2.5-1.93,1.87-2.06,3.49-1.31,3.95-1.31.49-.47,2.38-.75,2.83-.05.65-.7,2.5-.4,2.52.61,1.52-.31,3.47,1.3,3.97,2.77,1.37-.49,2.03.77,1.57,1.67.64,1.95.29,5.36-.95,7.03.2-.99.63-1.91-.62-4.42s-6.19-.9-7.09-.93c-1.35-.05-5.81-1.19-7.29.86-1.3,1.81-1.46,3.94-1.46,3.94-.42-.76-1.37-2.44-1.1-3.27-.02.07-.63-.79-.67-.92-.1-.36-.07-.78.08-1.12.46-1.02,1.58-.67,2.28-.08"
        style={{
          fill: '#312c32',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m30.92,11.62c-.68.23-1.11.23-1.52,1.27"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m32.25,12.98c-.81.09-1.57.58-2,1.28"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m24.42,8.32c-.15-.07-.26.14-.29.3-.13.7-.27,1.41-.4,2.11"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m20.85,8.31c.24-.06.46.17.6.38.55.85.85,1.86.88,2.88"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m17.34,9.67c.81.54,1.28,1.44,1.89,2.19.19.23.4.46.67.61.31.18.68.24,1,.41"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m14.45,11.65c.32-.08,1.11-.19,1.41-.06.28.13.52.32.76.51.42.35.82.71,1.2,1.1.21.21.43.44.72.52"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m26.9,8.62c-.56.48-.96,1.15-1.13,1.87"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m21.22,14.04c0-.74.58-1.34,1.12-1.84.68-.63,1.39-1.28,2.28-1.56,1.12-.36,2.29.36,4.43-.97"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m22.08,14.65c.53-.1,1.95-.49,2.27-.92s.57-.91.92-1.32c.96-1.13,3.18-1.15,4.54-.55"
        style={{
          fill: 'none',
          stroke: '#140f12',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
    </>
  </AvatarArtwork>
);
